import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { ConfigChangeLogListFeatureGate } from '../Guards/ConfigChangeLogListFeatureGate'
import { ConfigChangeLogList } from '../Components/Organisms/ConfigChangeLogList/ConfigChangeLogList'

/**
 * Routed audit trail (configuration change log) list page.
 */
@Route(RouteID.AUDIT_TRAIL)
export class ConfigChangeLogListPage extends Component {
    /**
     * Renders the audit trail list page content tree.
     *
     * @returns Audit trail list page tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.AUDIT_TRAIL}>
                <ConfigChangeLogListFeatureGate>
                    <LanguageContextProvider>
                        <ConfigChangeLogList />
                    </LanguageContextProvider>
                </ConfigChangeLogListFeatureGate>
            </RouteGuard>
        )
    }
}
